import { Dialog, DialogContent, Fade } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PackageService from '../../services/package';
import ListingService from '../../services/listing';
import PackageList from './PackageList';
import SkeletonPackageCard from '../placeholders/SkeletonPackageCard';

function PackageListDialog({ open, handleClose, listingSeq }) {
    const [packages, setPackages] = useState([]);
    const [listingData, setListingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [refreshList, setRefreshList] = useState(false)

    useEffect(() => {
        if (!listingSeq) return;

        let isMounted = true; // Prevents state updates after unmount

        setLoading(true); // Ensure loading state is set before fetching

        // Fetch Packages
        PackageService.getAllListingPackagesData(listingSeq, '', (data) => {
            if (isMounted) {
                setPackages(data.filter(pkg => parseInt(pkg.listing_seq) === parseInt(listingSeq)));
                setLoading(false);
            }
        });

        // Fetch Listing Data
        ListingService.getListingData(
            listingSeq,
            (data) => {
                if (isMounted) setListingData(data);
            },
            (error) => console.error('Error fetching listing data:', error)
        );

        return () => {
            isMounted = false; // Cleanup on unmount
        };
    }, [listingSeq, refreshList]);

    return (
        <Dialog
            sx={{ width: '100%', "& .MuiPaper-root": { maxWidth: 'md', width: '100%' } }}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
        >
            <DialogContent sx={{ transition: 'height 0.3s ease-in-out', minHeight: '600px' }}>
                {loading ? (
                    <>
                        <SkeletonPackageCard />
                        <SkeletonPackageCard />
                        <SkeletonPackageCard />
                    </>
                ) : (
                    <PackageList packages={packages} listingData={listingData} setRefreshList={setRefreshList} listing_seq={listingSeq} refreshList={refreshList} isPackageEditor={true} />
                )}
            </DialogContent>
        </Dialog>
    );
}

export default PackageListDialog;
